import { Component, HostListener, ViewChild} from '@angular/core';
import { AuthenticationService } from './services/security';
import * as moment from 'moment';
import { DisplayService } from './services';
import { debounce } from '@shared/decorator/debounce.decorator';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'Décisiel - Logiciel de gouvernance';
  headerVisible = false;
  goToTopButtonVisible: boolean;

  constructor(private displayService: DisplayService, private Location : Location,private authService: AuthenticationService, private router: Router) { }

  ngOnInit() {
    this.displayService.emitChangeResolution(window.innerWidth);
    moment.locale('fr'); 
    this.headerVisible = this.authService.IsAuthenticated();
    this.authService.authenticationState.subscribe(() => {
      this.headerVisible = this.authService.IsAuthenticated();
    });
   
  }
  isLoginRoute() {
     return this.authService.IsAuthenticated();
  }
  @HostListener("window:scroll", [])
  onWindowScroll() {
    this.goToTopButtonVisible = window.pageYOffset > 100;
  }

  @HostListener('window:resize', ['$event'])
  @debounce()
  onResize(event) {
    this.displayService.emitChangeResolution(window.innerWidth);
  }

  goToTopPage(){
    window.scroll({ 
      top: 0, 
      left: 0, 
      behavior: 'smooth' 
    });
  }
}
